@if (includeSideNav) {
	<app-side-nav>
		<router-outlet></router-outlet>
	</app-side-nav>
} @else {
	<router-outlet></router-outlet>
}
